"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _Hidden = _interopRequireDefault(require("@mui/material/Hidden"));
var _PageGrid = _interopRequireDefault(require("../PageGrid/PageGrid"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _HamburgerButton = _interopRequireDefault(require("../../../elements/HamburgerButton/HamburgerButton"));
var _Button = _interopRequireDefault(require("../../../elements/Button/Button"));
var _ButtonGroup = _interopRequireDefault(require("../../../components/ButtonGroup/ButtonGroup"));
var _Dropdown = _interopRequireDefault(require("../../../components/Dropdown/Dropdown"));
var _Link = _interopRequireDefault(require("../../../elements/Link/Link"));
var _Logo = _interopRequireDefault(require("../../../elements/Logo/Logo"));
var _MobileNavigation = _interopRequireDefault(require("../../../molecules/MobileNavigation/MobileNavigation"));
var _excluded = ["copy", "url"],
  _excluded2 = ["url"],
  _excluded3 = ["menuInfo", "mobileMenuInfo", "children"];
var _templateObject, _templateObject2, _templateObject3;
var StyledPageGrid = (0, _styledComponents.default)(_PageGrid.default)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  padding-top: 10px !important;\n  padding-bottom: 10px !important;\n"])));
var MiddleSection = (0, _styledComponents.default)(_Grid.default)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n"])));
var Buttonz = (0, _styledComponents.default)(_Grid.default)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  padding-left:0;\n  padding-right:0;\n"])));
var IndividualItem = function IndividualItem(_ref) {
  var copy = _ref.copy,
    url = _ref.url,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return _react.default.createElement(_Link.default, Object.assign({
    href: url
  }, props), _react.default.createElement(_MenuItem.default, props, copy));
};
var LogoGroup = function LogoGroup(_ref2) {
  var url = _ref2.url,
    props = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Hidden.default, {
    mdUp: true
  }, _react.default.createElement(_Grid.default, {
    container: true,
    item: true,
    justifyContent: "center",
    xs: 3,
    sm: 2,
    md: false
  }, _react.default.createElement(_Link.default, {
    href: url
  }, _react.default.createElement(_Logo.default, {
    small: true
  })))), _react.default.createElement(_Hidden.default, {
    mdDown: true
  }, _react.default.createElement(_Grid.default, {
    item: true,
    md: 1,
    justifyContent: "center"
  }, _react.default.createElement(_Link.default, {
    href: url
  }, _react.default.createElement(_Logo.default, {
    medium: true
  })))));
};
var TopNav = function TopNav(_ref3) {
  var menuInfo = _ref3.menuInfo,
    mobileMenuInfo = _ref3.mobileMenuInfo,
    children = _ref3.children,
    props = (0, _objectWithoutProperties2.default)(_ref3, _excluded3);
  return _react.default.createElement(StyledPageGrid, Object.assign({
    heroBackgroundColor: 'var(--bf-light-gray)'
  }, props), _react.default.createElement(_Grid.default, {
    container: true,
    alignItems: "center",
    alignContent: "center",
    justifyContent: "space-between"
  }, menuInfo.map(function (infoItem) {
    if (infoItem.data.slug === null) {
      return _react.default.createElement(_Hidden.default, {
        mdDown: true
      }, _react.default.createElement(_Link.default, null, _react.default.createElement(_Dropdown.default, {
        parentItem: infoItem,
        childItems: menuInfo.filter(function (menuInfo) {
          return menuInfo.data.Top_Nav_Position.includes("".concat(infoItem.data.Top_Nav_Position, "."));
        })
      })));
    } else if (infoItem.data.slug === '/') {
      return _react.default.createElement(LogoGroup, {
        url: infoItem.data.slug
      });
    } else if (infoItem.data.Top_Nav_Position.includes('.') || infoItem.data.Top_Nav_Position.includes('Button')) {
      return console.log('sub item');
    } else {
      return _react.default.createElement(_Hidden.default, {
        mdDown: true
      }, _react.default.createElement(_Link.default, Object.assign({
        href: infoItem.data.slug
      }, props), _react.default.createElement(_Button.default, {
        transparent: true
      }, infoItem.data.title)));
    }
  }), _react.default.createElement(_Hidden.default, {
    lgDown: true
  }, _react.default.createElement(MiddleSection, {
    item: true,
    sm: 1
  })), _react.default.createElement(_Hidden.default, {
    mdUp: true
  }, _react.default.createElement(_Dropdown.default, {
    parentItem: {
      'data': {
        'title': '≡'
      }
    },
    childItems: mobileMenuInfo
  })), _react.default.createElement(_Hidden.default, {
    mdDown: true
  }, _react.default.createElement(Buttonz, {
    item: true,
    container: true,
    md: 4,
    lg: 4
  }, _react.default.createElement(_ButtonGroup.default, {
    primaryLabel: menuInfo.filter(function (menuInfo) {
      return menuInfo.data.Top_Nav_Position === '8 - Filled Button';
    })[0].data.title,
    invertedLabel: menuInfo.filter(function (menuInfo) {
      return menuInfo.data.Top_Nav_Position === '7 - Inverted Button';
    })[0].data.title,
    primaryUrl: menuInfo.filter(function (menuInfo) {
      return menuInfo.data.Top_Nav_Position === '8 - Filled Button';
    })[0].data.slug,
    invertedUrl: menuInfo.filter(function (menuInfo) {
      return menuInfo.data.Top_Nav_Position === '7 - Inverted Button';
    })[0].data.slug
  })))));
};
var _default = TopNav;
exports.default = _default;